module.exports = __webpack_public_path__ + "static/media/photo26.eee66002.jpg";